/**
 * Shared Stripe Customer Portal + Checkout (Navbar + Account + Paywall Pack Pass).
 */

import { apiClient, ApiError } from './apiClient';
import { PACK_PASS_SKU } from '../utils/packPass';

export async function openStripeBillingPortal(token: string): Promise<{ url: string }> {
  const response = await apiClient.post('/api/stripe/create-portal', {}, { token }) as { url?: string };
  if (!response?.url) {
    throw new ApiError('Billing portal URL missing', 502, null);
  }
  return { url: response.url };
}

export async function createStripeCheckoutSession(
  token: string,
  body: {
    planType?: 'Pro';
    sku?: typeof PACK_PASS_SKU | 'pack_pass';
    engagementId?: string;
    lang?: string;
    currency?: string;
  },
): Promise<{ url: string; sku?: string }> {
  const response = await apiClient.post('/api/stripe/create-checkout', body, { token }) as { url?: string; sku?: string };
  if (!response?.url) {
    throw new ApiError('Checkout URL missing', 502, null);
  }
  return { url: response.url, sku: response.sku };
}

export type VerifyCheckoutResult = {
  verified: boolean;
  transactionId?: string;
  sku?: 'Pro' | 'pack_pass';
  engagementId?: string | null;
  currency?: string | null;
  amountTotal?: number | null;
  paymentStatus?: string | null;
  code?: string;
};

/** Authenticated Stripe session check before GA4/Ads purchase commerce. */
export async function verifyStripeCheckoutSession(
  token: string,
  sessionId: string,
): Promise<VerifyCheckoutResult> {
  const response = await apiClient.post(
    '/api/stripe/verify-checkout',
    { sessionId },
    { token },
  ) as VerifyCheckoutResult;
  return {
    verified: Boolean(response?.verified),
    transactionId: response?.transactionId,
    sku: response?.sku,
    engagementId: response?.engagementId,
    currency: response?.currency,
    amountTotal: response?.amountTotal,
    paymentStatus: response?.paymentStatus,
    code: response?.code,
  };
}
